
//import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './passes.less'
import App from './App.jsx'

import * as buffer from "buffer"

import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import '@fontsource/roboto/900.css'

window.Buffer = buffer.Buffer

createRoot(document.getElementById('app')).render(
  <App />
)